<template>
  <div>
      <b-card 
      >
      <template #header>
          <div class="d-flex justify-content-between" style="width: 100%;">
            <h3>Summary</h3>
            <b-dropdown
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            right
            variant="outline-primary"
            text="Export"
            class="mr-3"
            >
              <b-dropdown-item 
                @click="exportToExcel(
                  items,
                  ['Total Data', 'Total Distractor', 'Total Passive', 'Total Promotors', 'Rate', 'Quartal'],
                  ['total','total_distractor', 'total_passive', 'total_promotors', 'rate', 'quartal'],
                  'NPS Rating Summary ' + year,
                  formatJson
                )"

              >As Excel</b-dropdown-item>
            </b-dropdown>
          </div>
      </template>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Year</label>
          <v-select
            v-model="year"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="years"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
        </b-col>

      </b-row>
    </div>
    <div class="mx-1 mb-1">
    </div>
        <b-table 
          responsive
          :sort-by.sync="sortBy" 
          :sort-desc.sync="sortDesc" 
          :items="computedItems" 
          :fields="fields" 
          :no-local-sorting="true" 
          @sort-changed="sortingChanged"
          :busy="isBusy"
        >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
                <strong class="text-secondary">Loading...</strong>
              </div>
            </template>
            <template #cell(total)="data">
              <div v-if="data.item.quartal === 'TOTAL'" style="font-weight: 900;"> {{ data.value }} </div>
              <div v-else> {{ data.value }} </div>
            </template>
            <template #cell(total_distractor)="data">
              <div v-if="data.item.quartal === 'TOTAL'" style="font-weight: 900;"> {{ data.value }} </div>
              <div v-else> {{ data.value }} </div>
            </template>
            <template #cell(total_passive)="data">
              <div v-if="data.item.quartal === 'TOTAL'" style="font-weight: 900;"> {{ data.value }} </div>
              <div v-else> {{ data.value }} </div>
            </template>
            <template #cell(total_promotors)="data">
              <div v-if="data.item.quartal === 'TOTAL'" style="font-weight: 900;"> {{ data.value }} </div>
              <div v-else> {{ data.value }} </div>
            </template>
            <template #cell(rate)="data">
              <div v-if="data.item.quartal === 'TOTAL'" style="font-weight: 900;"> {{ data.value }} (Average) </div>
              <div v-else> {{ data.value }} </div>
            </template>
            <template #cell(quartal)="data">
              <div v-if="data.item.quartal === 'TOTAL'" style="font-weight: 900;"> {{ data.value }} </div>
              <div v-else> {{ data.value }} </div>
            </template>
        </b-table>
      </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BSpinner, BFormCheckbox, BModal, BImg
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import VueHtml2pdf from 'vue-html2pdf'
import { generateToken } from '@/auth/helperAuth'
import axios from '@/libs/axios'
export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,

    vSelect,
    VueHtml2pdf,

  },
  data() {
    return {
      token: '',
      perPage: '10',
      perPageOptions: ['10', '20', '30', '50', '100', '500', '1000', 'all'],
      currentPage: 1,
      totalData: 200,
      showData: 0,
      items: [],
      sortBy: 'CREATED_DATE',
      sortDesc: true,
      searchWord: '',
      isBusy: false,

      selectedItem: {
        icon: '',
        icon_details: {}
      },
      year: new Date().getFullYear(),
      years: [],
    }
  },
  directives: {
    Ripple,
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
  },
  computed: {
    skip() {
      if (Number.isNaN(parseInt(this.perPage))) {
        return 0
      }
      return this.perPage * (this.currentPage - 1)
    },
    imgSelectedItem() {
      return typeof this.selectedItem.icon_details === 'object' && typeof this.selectedItem.icon_details.original === 'object' ? this.selectedItem.icon_details.original.url : ''
    },
    isApprover() {
      let permissions = this.$store.getters['oauth/getActiveUser'].permissions
      if (!permissions.includes('aprove_product')) {
        return false
      }
      return true
    },
    fields() {
      let toShow = [
        'quartal',
        'rate',
        {key: 'total_promotors', label: 'Promoters'},
        {key: 'total_passive', label: 'Passives'},
        {key: 'total_distractor', label: 'Detractors'},
        {key: 'total', label: 'total data'},
      ]
      return toShow
    },
    computedItems() {
      let totalTotal = 0
      let totalDistractor = 0
      let totalPassive = 0
      let totalPromotors = 0
      let totalRate = 0
      let divideBy = 0
      this.items.forEach(element => {
        totalTotal += element.total
        totalDistractor += element.total_distractor
        totalPassive += element.total_passive
        totalPromotors += element.total_promotors
        totalRate += element.rate
        if (element.rate !== 0 ) {
          divideBy++
        }
      });
      
      return [
        ...this.items,
        {
          total: totalTotal,
          total_distractor: totalDistractor,
          total_passive: totalPassive,
          total_promotors: totalPromotors,
          quartal: 'TOTAL',
          rate: Math.ceil(totalRate / divideBy)
        }
      ]
    }
  },
  watch: {
    perPage() {
      this.getNPS()
    },
    currentPage() {
      this.getNPS()
    },
    searchWord() {
      this.$store.dispatch('app/search', {
        callback: () => {
          this.getNPS()
        }
      })
    },
    year() {
      this.getNPS()
    },
  },
  mounted() {
    this.fetchYears()
    this.getNPS()
  },
  methods: {
    async fetchYears(){
      return await axios.post('/rating/fetchYear', {
        res: null
      })
      .then(res => {
          this.years = res.data
      })
      .catch(err => console.error(err))
      .finally()
    },
    async getNPS() {
      let searchWord  = this.searchWord.trim()
      let base = '/rating/case/result-admin/take/all'
      let year = `/year/${this.year}`
      // let take = `/take/${this.perPage}`
      // let skip = `/skip/${this.skip}`
      // let search = `${searchWord !== '' ? `/s/${searchWord}`: ''}`
      // let orderBy = `/orderBy.${this.sortBy}/${this.sortDesc === true ? 'desc' : 'asc'}`
      let complete = base + year
      this.isBusy = true
      return await this.$http.get(complete)
      .then( res => {
        this.items = res.data.data.records
        this.totalData = res.data.data.total
        this.showData = res.data.data.show
      })
      .catch( err => {
        console.error(err)
      })
      .finally(() => {
        this.isBusy = false
      })
    },
    inputPagination(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc}) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.getNPS()
      }
    },
    generateTipe(score) {
        if (score > 8) {
            return "Promoter"
        } else if (score < 7) {
            return "Detractors"
        } else {
            return "Passives"
        }
    },
    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data = v[j]

        return data
      }))
    },
    generateReport () {
        this.$refs.html2Pdf.generatePdf()
    },
    onPDFProgress(event) {
    },
    hasStartedGeneration() {},
    hasGenerated (event) {},
    getMonth(date) {
      return 1 + this.$moment(date).month()
    },
    getQuartal(date) {
      return Math.ceil(this.getMonth(date) / 3)
    },
    getYear(date) {
      return this.$moment(date).year()
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>